import { render, staticRenderFns } from "./corporateTransfer.vue?vue&type=template&id=b21fd024&scoped=true"
import script from "./corporateTransfer.vue?vue&type=script&lang=js"
export * from "./corporateTransfer.vue?vue&type=script&lang=js"
import style0 from "./corporateTransfer.vue?vue&type=style&index=0&id=b21fd024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21fd024",
  null
  
)

export default component.exports